<template>
  <div class="container pb-16">
    <navigation-drawer :titles="'لیست صفحه ها'"/>
    <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="input-border mb-1"
        label="جستجو"
        single-line
        solo></v-text-field>
    <v-data-table
        :expanded.sync="expanded"
        show-expand
        :single-expand="singleExpand"
        id="dataTable"
        :headers="headers"
        :items="list"
        :items-per-page="10"
        :light="true"
        :mobile-breakpoint="680"
        :search="search"
        class="data-table"
        fixed-header
        item-key="PageId"
    >
      <template v-slot:[`item.FileUrl`]="{ item }">
        <div class="p-2 d-flex justify-content-center">
          <v-img v-if="item.FileUrl != null" :src="$replaceHttps(item.FileUrl)" height="110"
                 width="110" contain>
          </v-img>
          <v-img v-else :src="getImgUrl(src)" height="50"
                 width="50" contain></v-img>
        </div>
      </template>
      <template v-slot:[`item.TypePage`]="{ item }">
        <div class="p-2 d-flex justify-content-center">
          {{ $typePages[item.TypePage - 1].name }}
        </div>
      </template>
      <template  v-slot:[`item.Link`]="{ item }">
        <a v-if="item.Link !== null" :href="item.Link" target="_blank">
          <v-btn color="primary" class="rounded-lg " elevation="0"
          >
            <span class="font16px">لینک</span>
          </v-btn>
        </a>
      </template>
      <template v-slot:expanded-item="{ item }">
        <td>
          <div v-if="item.Description === null">
            بدون توضیح
          </div>
          <div v-else>
            <div v-html="item.Description"></div>
          </div>

        </td>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
            color="primary"
            elevation="0"
            :to="{path: 'definePages', query:{isNew:false , id:item.PageId}}"
        >
          <i class="fas fa-edit white--text"></i>
        </v-btn>
      </template>
    </v-data-table>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>

import NavigationDrawer from "@/Admin/components/navigationDrawer";

export default {
  name: "listPages",
  components: {NavigationDrawer},
  metaInfo() {
    return {
      title: 'ادمین تیکتینگ-لیست صفحه ها '
    }
  },
  data: () => ({
    showLoaderDialog: false,
    expanded: [],
    singleExpand: true,
    headers: [
      {text: 'عکس', value: 'FileUrl', sortable: false,},
      {text: 'نوع', value: 'TypePage', sortable: false,},
      {text: 'توضیحات', value: 'data-table-expand', sortable: false,},
      {text: 'لینک', value: 'Link', sortable: false,},
      {text: 'ویرایش', value: 'actions', sortable: false,},
    ],
    list: [],
    search: null,
    src: 'logo.png'
  }),
  mounted() {
    if (this.$getUserData().token === '') {
      this.$router.replace({path: '/'})
    }
    this.getData()
  },
  watch: {
    '$route.query.isNew'() {
      location.reload()
    }
  },
  methods: {
    getImgUrl(pic) {
      return require('../../assets/img/' + pic)
    },

    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/PagesList", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.list = JSON.parse(result)
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>